import { User, FitnessConsumerProfile } from '../models';
import { PartnerRoleResponse } from '@fitscovery/partner/data-access';

export interface UserStateModel {
  info: User | null;
  fitnessConsumerProfile: FitnessConsumerProfile | null;
  partners: PartnerRoleResponse[] | null;
  loaded: boolean;
}

export interface UsersStateModel {
  users: User[];
  user: User | null;
}

export enum Gender {
	NoneProvided = 0,
	Male,
	Female,
	NotSpecified = 9
}
